import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import Header from 'organisms/Header';
import { 
  isAuthenticated as isAuthenticatedSelector,
  isInitialAuthDone as isInitialAuthDoneSelector 
} from 'features/Auth/selectors';
import LoadingScreen from 'features/LoadingScreen/components';

import { ROUTES } from 'navigation/constants';

const ProtectedRoute = () => {
  const location = useLocation();
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const isAuthInitialized = useSelector(isInitialAuthDoneSelector);

  // Show loading screen while auth is initializing
  if (!isAuthInitialized) {
    return <LoadingScreen />;
  }

  // Redirect to landing if not authenticated after initialization
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LANDING.path} state={{ from: location }} replace />;
  }

  return (
    <>
      <Header />
      <Outlet />
    </>
  );
};

export default ProtectedRoute;
